var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.verification_message.length > 0)?_c('div',[_vm._v(" "+_vm._s(_vm.verification_message)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }